import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "toggle"];
  static values = { maxLines: Number };

  connect() {
    this.maxLines = this.hasMaxLinesValue ? this.maxLinesValue : 5;
    this.checkIfCollapsible();
  }

  checkIfCollapsible() {
    if (!this.hasContentTarget) return;

    const content = this.contentTarget;
    const listItems = content.querySelectorAll("li");
    const itemCount = listItems.length;

    if (itemCount > this.maxLines) {
      this.isCollapsible = true;
      this.isCollapsed = true;
      this.collapse();
      if (this.hasToggleTarget) {
        this.toggleTarget.style.display = "inline-block";
        this.toggleTarget.textContent = "Show more";
      }
    } else {
      this.isCollapsible = false;
      if (this.hasToggleTarget) {
        this.toggleTarget.style.display = "none";
      }
    }
  }

  collapse() {
    if (!this.hasContentTarget) return;
    const content = this.contentTarget;
    const listItems = content.querySelectorAll("li");
    
    // Hide items beyond maxLines
    listItems.forEach((item, index) => {
      if (index >= this.maxLines) {
        item.style.display = "none";
      }
    });
  }

  expand() {
    if (!this.hasContentTarget) return;
    const content = this.contentTarget;
    const listItems = content.querySelectorAll("li");
    
    // Show all items
    listItems.forEach((item) => {
      item.style.display = "";
    });
  }

  toggle(event) {
    event.preventDefault();
    if (!this.isCollapsible) return;

    this.isCollapsed = !this.isCollapsed;

    if (this.isCollapsed) {
      this.collapse();
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = "Show more";
      }
    } else {
      this.expand();
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = "Show less";
      }
    }
  }
}

